import { createReducer } from '@reduxjs/toolkit';
import {
    loginRequest,
    loginSuccess,
    loginFailure,
    deleteRequest,
    deleteSuccess,
    deleteFailure,
    signupRequest,
    signupSuccess,
    signupFailure,
    checkEmailRequest,
    checkEmailSuccess,
    checkEmailFailure,
    resetPasswordRequest,
    resetPasswordSuccess,
    resetPasswordFailure,
    resetErrorRequest,
    loadingOnRequest,
    loadingOffRequest,
    logoutRequest,
    LoginResponse,
    SignupResponse,
    profileRequest,
    profileSuccess,
    profileFailure,
    profileUpdateRequest,
    profileUpdateSuccess,
    profileUpdateFailure,
    EmailStatusResponse,
    constantsRequest,
    constantsSuccess,
    constantsFailure,
    ConstantsResponse,
    rolesRequest,
    rolesSuccess,
    rolesFailure,
    Role,
    teamsRequest,
    teamsSuccess,
    teamsFailure,
    Team,
} from './actions';


export interface AuthState {
    teams: Team[] | null;
    roles: Role[] | null;
    auth: LoginResponse | SignupResponse | null;
    constants: ConstantsResponse | null;
    is_email_valid: EmailStatusResponse | null;
    reset_password: boolean | null;
    loading: boolean;
    error: string | null;
}

const initialState:AuthState = {
    teams: null,
    roles: null,
    auth: null,
    constants: null,
    is_email_valid: null,
    reset_password: null,
    loading: false,
    error: null,
};

const authReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(loginRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(loginSuccess, (state, action) => {
            state.loading = false;
            state.auth = action.payload;
            localStorage.setItem('authToken', action.payload.token);
            window.dispatchEvent(new Event("storage"));
        })
        .addCase(loginFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(profileRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(profileSuccess, (state, action) => {
            state.loading = false;
            state.auth = {...state.auth, 'user': action.payload } as LoginResponse;
        })
        .addCase(profileFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(profileUpdateRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(profileUpdateSuccess, (state, action) => {
            state.loading = false;
            state.auth = {...state.auth, 'user': action.payload } as LoginResponse;
        })
        .addCase(profileUpdateFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(deleteRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(deleteSuccess, (state) => {
            localStorage.removeItem('authToken');
            state.auth = null;
            state.error = null;
            state.loading = false;
        })
        .addCase(deleteFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(constantsRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(constantsSuccess, (state, action) => {
            state.loading = false;
            state.constants = action.payload;
        })
        .addCase(constantsFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(signupRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(signupSuccess, (state, action) => {
            state.loading = false;
            localStorage.setItem('authToken', action.payload.token);
            state.auth = action.payload;
        })
        .addCase(signupFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(checkEmailRequest, (state) => {
            state.loading = true;
            state.error = null;
            state.is_email_valid = null;
        })
        .addCase(checkEmailSuccess, (state, action) => {
            state.loading = false;
            state.is_email_valid = action.payload;
        })
        .addCase(checkEmailFailure, (state, action) => {
            state.loading = false;
            state.is_email_valid = null;
            state.error = action.payload;
        })
        .addCase(resetPasswordRequest, (state) => {
            state.loading = true;
            state.error = null;
            state.reset_password = null;
        })
        .addCase(resetPasswordSuccess, (state, action) => {
            state.loading = false;
            state.reset_password = action.payload;
        })
        .addCase(resetPasswordFailure, (state, action) => {
            state.loading = false;
            state.reset_password = null;
            state.error = action.payload;
        })
        .addCase(resetErrorRequest, (state) => {
            state.error = null;
            state.reset_password = null;
        })
        .addCase(loadingOnRequest, (state) => {
            state.loading = true;
        })
        .addCase(loadingOffRequest, (state) => {
            state.loading = false;
        })
        .addCase(logoutRequest, (state) => {
            localStorage.removeItem('authToken');
            state.auth = null;
            state.error = null;
            state.loading = false;
        })
        .addCase(rolesRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(rolesSuccess, (state, action) => {
            state.loading = false;
            state.roles = action.payload;
        })
        .addCase(rolesFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(teamsRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(teamsSuccess, (state, action) => {
            state.loading = false;
            state.teams = action.payload;
        })
        .addCase(teamsFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
});

export default authReducer;
